import { SelectField } from "@/components/ui/form/fields/select-field";

import { useReservationDefaultPlanID } from "./hooks";

export const QuestionReservationDefaultPlanID = () => {
	const { defaultPlanID, onSetRequiredDefaultPlanID, defaultPlanIDOptions } = useReservationDefaultPlanID();

	const label = "最初に自動で選択されるプラン";

	return (
		<div className="flex flex-col gap-y-4">
			<SelectField
				label={label}
				value={defaultPlanID?.value || "null"}
				errorMessage={defaultPlanID?.error}
				options={defaultPlanIDOptions}
				handleValueChange={onSetRequiredDefaultPlanID}
			/>
			<p className="text-sm text-brand">
				※「プラン選択を必須にしている場合」、「プラン選択を必須にしていない場合」のどちらの場合でも最初に自動で選択されるプランは設定できます。
			</p>
		</div>
	);
};

QuestionReservationDefaultPlanID.displayName = "QuestionReservationDefaultPlanID";
